/* eslint-disable no-debugger */
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
// material
import {
  Typography,
  Stack,
  TableContainer,
  Table,
  Paper,
  TableBody,
  TableCell,
  TableRow,
  Container
} from '@material-ui/core';
// ----------------------------------------------------------------------

CustomerTableData.propTypes = {
  Data: PropTypes.array
};

export default function CustomerTableData({ Data }) {
  const [showResult, setShowResult] = useState(false);

  const handleShowResult = () => {
    setShowResult(!showResult);
  };

  return (
    <Container>
      <Paper>
        <Stack spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
            <TableContainer>
              <Table sx={{ border: 1 }}>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ border: '1px solid', padding: '10px', backgroundColor: '#F4F6F8' }}>
                      <Typography variant="h6" color={(theme) => theme.palette.primary.main}>
                        Customer Account Info
                      </Typography>
                    </TableCell>
                  </TableRow>
                  {Data?.map((obj, i) =>
                    Object.keys(Data[i])?.map((value) => (
                      <TableRow key={i}>
                        <TableCell style={{ border: '1px solid', padding: '10px' }}>
                          <Typography variant="subtitle2">{value}</Typography>
                        </TableCell>
                        <TableCell align="right" style={{ border: '1px solid', padding: '10px' }}>
                          {obj[value]}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
}
